'use client';
/* Built In Imports */
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import {
  ChevronDownIcon,
  ChevronRightIcon,
  HamburgerIcon,
} from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Icon,
  Image,
  Input,
  List,
  ListItem,
  Portal,
  Show,
  SimpleGrid,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import forEach from 'lodash/forEach';
import { FaRegCheckCircle } from 'react-icons/fa';
import { GoCalendar } from 'react-icons/go';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Component */
import MobMenu from '@app-ps/Components/Header/MobMenu';
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/* Styles */
/* Services */
import { fetchMenuItem } from 'services/projSamskritiService';
import { handleKarmaNavigation } from '../utils';

/**
 * Renders Header Component
 * @param {Obj} headerMenuData
 * @param {Str} region
 * @param {Str} language
 * @returns {ReactElement} Header
 */
const Header = ({
  headerMenuData,
  region,
  language,
  // theme,
  headerMenuDataCopy,
}) => {
  // console.log(headerMenuData, 'header data');
  const [isPathChanged, setIsPathChanged] = useState(false);
  const [headerData, setHeaderData] = useState(headerMenuData?.allIsoMainMenus);
  const engage = headerData?.find(el => el?.key === 'hollow-btn');
  const calender = headerData?.find(el => el?.key === 'calender');
  const [activeInput, setActiveInput] = useState(false);
  const [mIndex, setMIndex] = useState({});
  const [menuLoaded, setMenuLoaded] = useState(false);
  const pathName = usePathname();
  const router = useRouter();
  const [showPrograms, setShowPrograms] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 960 });
  const ref = useRef(null);
  const [inputValue, setInputValue] = useState(null);
  let [megaMenu, triggerMegaMenu] = useState(false)
  const searchParams = useSearchParams();

  const [megaMenuOpen, setMegaMenuOpen] = useState(false);

  let hamburgerIconSize = useBreakpointValue({base: '24px', md: '30px'})

  // console.log('headerMenuData', headerMenuData);
  const [isMegaMenu, setIsMegaMenu] = useState(-1);
  const callMenuData = async id => {
    setHeaderData(headerMenuDataCopy?.allIsoMainMenus);
    const menuData = await fetchMenuItem(id);
    setMenuLoaded(true);
    const newHeaderData = headerMenuDataCopy?.allIsoMainMenus;

    forEach(newHeaderData, function (menuItem) {
      if (menuItem?.key === 'productions') {
        // console.log('menuData21', menuItem);
        forEach(menuItem?.submenuItems, function (subItem) {
          if (menuData[subItem?.key]) {
            let newMenuList = formatMenuData(menuData[subItem?.key]);
            subItem.submenuItems = newMenuList.concat(subItem.submenuItems);
          }
        });
      }
    });
    setHeaderData(newHeaderData);
  };

  const formatMenuData = menuList => {
    let newMenuList = [];
    forEach(menuList, function (menuItem) {
      newMenuList.push({
        icon: 'https://static.sadhguru.org/d/46272/1724171770-ticket-admit-vip.png',
        iconHover: '',
        title: menuItem.title,
        type: 'upcoming',
        url: `productions/upcoming?id=${menuItem.program_id}`,
      });
    });
    return newMenuList;
  };

  useEffect(() => {
    const handleMouseLeaveWindow = (e) => {
      if (!e.relatedTarget && !e.toElement) {
        // Force hide by adding a class
        document.body.classList.add("force-hide-mega");
        setMegaMenuOpen(false)
      }
    };
    const handleMouseEnterWindow = () => {
      // Remove force hide so CSS can work normally
      document.body.classList.remove("force-hide-mega");
    };
    document.addEventListener("mouseleave", handleMouseLeaveWindow);
    document.addEventListener("mouseenter", handleMouseEnterWindow);
    return () => {
      document.removeEventListener("mouseleave", handleMouseLeaveWindow);
      document.removeEventListener("mouseenter", handleMouseEnterWindow);
    };
  }, [isMegaMenu]);


  useEffect(() => {
    document.body.style.overflow = showPrograms && isMobile ? 'hidden' : 'auto';
    // setTimeout(function () {
    // }, 1500);
  }, [showPrograms]);

  useEffect(() => {
    callMenuData();
  }, [headerMenuDataCopy]);

  useEffect(() => {
    setShowPrograms(false);
    setIsMegaMenu(-1);
    // let i = 0;
    // console.log(i++)
    setIsPathChanged(true);
    // console.log(isPathChanged, "isPathChanged");
    setTimeout(() => {
      setIsPathChanged(false); // for fallback conditions
    }, 1000);
    return () => setIsPathChanged(true);
  }, [pathName, searchParams]);

  const { isOpen } = useDisclosure();
  const theme = 'light';
  const position = pathName === '/project-samskriti' ? 'absolute' : 'relative';

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  const goToSearch = () => {
    router.push(`/project-samskriti/search?q=${ref.current.value}`, {
      scroll: false,
    });
  };

  let paddingForLi = useBreakpointValue({base: '0 5px',  '2xl': '0 15px'})
  let navWidth =  useBreakpointValue({xl: '900px', '2xl': 'auto'})
  let getBookBtnMarging = useBreakpointValue({xl:"3rem", '2xl': '1%'})
  let navStyle = useBreakpointValue({xl: {alignItems:'center', display: 'flex'}, '2xl': {}})

  // return <></>
  return headerData?.length > 0 ? (
    <Box
      id={'karmaMainMenu'}
      pb={{ base: '0px', md: '22px' }}
      width={'100%'}
      maxH={{ lg: '100px' }}
      pt={{ base: '0px', md: '15px' }}
      // height={{ base: '96px', md: '100%' }}
      height={{ base: '52px', md: '80px' }}
      px={{
        base: '2%',
        md: '2%',
        lg: '2%',
        '2xl': '2%',
      }}
      pos={position}
      // pr={{
      //   base: '5%',
      //   md: '3%',
      //   lg: '5%',
      // }}
      bg={'linear-gradient(180deg, #030040 0%, #030040 100%)'}
      // id="ps-header"
      // pos="relative"
      zIndex={100}
    >
      <Box
        className="desktopMenu"
        display="flex"
        // justifyContent="space-between"
        alignItems="center"
        w="full"
        maxW={{ base: 'container.xl', lg: '95%', xl: 'full' }}
        mx="auto"
      >
        <Link
          href={handleKarmaNavigation('')}
          _hover={{ textDecor: 'none', color: '#60ADFF' }}
          _focus={{ boxShadow: 'none' }}
          pl={{ base: '10px', md: 0 }}
          pos="relative"
          visibility={{
            base: activeInput ? 'hidden' : 'visible',
            md: 'visible',
          }}
          zIndex="5"
          prefetch
          mr={{
            base: '1rem',
            md: '3%',
            lg: '2.5%',
            xl: '3rem',
            '2xl': '3%',
          }}
        >
          <Image
            src={`${config.imgPath}/d/46272/1751704407-karmabooknavlogo.png`}
            width={{base: '31.73px', md:'55px'}}
            height={{base: '30px', md: '52px'}}
            alt="logo"
            priority="true"
            maxW={182}
            ml={{base: "0.3rem", md: '0.7rem', lg: '0px', xl: '3rem', '2xl': '0px' }}
          />
        </Link>
        <Show above="lg">
          <nav style={{width: navWidth}} > 
            <ul className="container ul-reset" style={navStyle}>
              {headerData?.map((menu, key) => {
                if (
                  menu.key === 'logo' ||
                  menu.key === 'search' ||
                  menu.key === 'calender' ||
                  menu.key === 'hollow-btn' ||
                  menu.key === 'blog' || 
                  menu.key === 'karma_basics'
                ) {
                  return null;
                } 
                else if (typeof window !== 'undefined' && !window.location.href?.includes('karma-book') && menu.key === 'get_your_book') {
                  const [path, hash] = window.location.href.split("#");
                  return <li
                  style={{position:'absolute', right:getBookBtnMarging, top:'24px'}}
                  >
                    <Button 
                    borderRadius={'6px'}
                    bg={'transparent'}
                    textTransform={'uppercase'}
                    fontFamily={'var(--FedraSansStd-medium)'}
                    fontSize={'14px'}
                    fontWeight={500}
                    width={'160px'}
                    height={'36px'}
                    lineHeight={'36px'}
                    padding={'0px'}
                    _hover={{
                      backgroundColor:'#FFFFFF66'
                    }}
                    >
                      <Link className='no-underline'
                      // href={handleKarmaNavigation(menu.url)}
                      href={path + menu.url}
                      >
                      {menu.title}
                      </Link>
                    </Button>
                  </li>
                }
                else if (menu.submenuItems.length > 0) {
                  const len = menu.submenuItems.length;

                  let firstPart = [];
                  let secondPart = [];
                  let thirdPart = [];

                  if (len <= 7) {
                    firstPart = menu.submenuItems; // all in one
                  } else if (len <= 14) {
                    firstPart = menu.submenuItems.slice(0, 7);
                    secondPart = menu.submenuItems.slice(7);
                  } else {
                    firstPart = menu.submenuItems.slice(0, 7);
                    secondPart = menu.submenuItems.slice(7, 14);
                    thirdPart = menu.submenuItems.slice(14);
                  }

                  return (
                    <li
                      className="droppable"
                      key={key}
                      onMouseEnter={() => {
                        setIsMegaMenu(key);
                        setMegaMenuOpen(true);
                      }}
                    >
                      <Text
                      className="droppable"
                        fontSize="1rem"
                        fontFamily="var(--FedraSansStd-book)"
                        color="#FFFFFF"
                        cursor={'pointer'}
                      >
                        <Link
                          className='no-underline'
                          href={handleKarmaNavigation(menu.url)}
                          _focus={{ boxShadow: 'none' }}
                          prefetch
                        >
                          {' '}
                          {menu.title} </Link> <ChevronDownIcon transform={megaMenuOpen && isMegaMenu / 1 === key / 1 ? 'rotate(180deg)' : 'unset'} 
                          position={{xl: 'absolute', '2xl': 'relative'}} top={{xl: '0.9rem', '2xl': 'unset'}} right={{xl: '0.8rem', '2xl': 'unset'}} className='desktopDDIcon' color={megaMenuOpen && isMegaMenu / 1 === key / 1 ? '#B7870C' : '#fff'} w={6} h={6} />
                      </Text>

                      <Box
                        className="mega-menu" pt={'10px'} style={{left: menu.title?.includes('Sadhana') ? '-100px' : "0px"}}>
                        <Box
                          height="auto"
                          bg={'#fff'}
                          top={'35px'}
                          py={'10px'}
                          px={'6px'}
                          display={megaMenuOpen && isMegaMenu / 1 === key / 1 ? 'flex' : 'none'}
                          // maxH={'460px'} 
                          overflowY={'scroll'}
                          sx={{
                            '&::-webkit-scrollbar': {
                              display: 'none'
                            },
                            '-ms-overflow-style': 'none',
                            'scrollbarWidth': 'none'
                          }}
                          flexDir={'row'}
                          borderRadius={'6px'}
                          border={'1px solid #B7870C'}
                        >
                          <Flex display={firstPart?.length ? 'flex' : 'none'} w="196px" justifyContent={'center'} alignItems={'center'}
                            height="100%" bg={'#FFFFFF'}
                            flexDir={'column'}>
                            {firstPart.map((sub, key1) => {
                              return (<>
                                <Link
                                  className='no-underline'
                                  href={handleKarmaNavigation(sub.url)}
                                  key={key1}
                                  fontFamily="var(--FedraSansStd-book)"
                                  fontSize="14px"
                                  color={window.location.href?.includes(sub.url) ? '#000000' : "#B7870C"}
                                  fontWeight="400"
                                  py={'12.5px'}
                                  px={'20px'}
                                  width={'100%'}
                                  _hover={{ bgColor: "#F8F3B5" }}
                                >
                                  {sub.title}
                                </Link>
                              </>
                              );
                            })}
                          </Flex>

                          <Flex display={secondPart?.length ? 'flex' : 'none'} w="196px" justifyContent={'center'} alignItems={'center'}
                            height="100%" bg={'#FFFFFF'}
                            flexDir={'column'}>
                            {secondPart.map((sub, key1) => {
                              return (<>
                                <Link
                                  className='no-underline'
                                  href={handleKarmaNavigation(sub.url)}
                                  key={key1}
                                  fontFamily="var(--FedraSansStd-book)"
                                  fontSize="14px"
                                  color={window.location.href?.includes(sub.url) ? '#000000' : "#B7870C"}
                                  fontWeight="400"
                                  py={'12.5px'}
                                  px={'20px'}
                                  width={'100%'}
                                  _hover={{ bgColor: "#F8F3B5" }}
                                >
                                  {sub.title}
                                </Link>
                              </>
                              );
                            })}
                          </Flex>

                          <Flex display={thirdPart?.length ? 'flex' : 'none'} w="196px" justifyContent={'center'} alignItems={'center'}
                            height="100%" bg={'#FFFFFF'}
                            flexDir={'column'}>
                            {thirdPart.map((sub, key1) => {
                              return (<>
                                <Link
                                  className='no-underline'
                                  href={handleKarmaNavigation(sub.url)}
                                  key={key1}
                                  fontFamily="var(--FedraSansStd-book)"
                                  fontSize="14px"
                                  color={window.location.href?.includes(sub.url) ? '#000000' : "#B7870C"}
                                  fontWeight="400"
                                  py={'12.5px'}
                                  px={'20px'}
                                  width={'100%'}
                                  _hover={{ bgColor: "#F8F3B5" }}
                                >
                                  {sub.title}
                                </Link>
                              </>
                              );
                            })}
                          </Flex>
                        </Box>
                      </Box>
                    </li>
                  );
                } 
                else if (menu.key != "karma_basics" && menu.key != 'get_your_book') {
                  return (
                    <li cursor={'pointer'}>
                      <Text
                        cursor={'pointer'}
                        fontSize="1rem"
                        fontFamily="var(--FedraSansStd-book)"
                        color="#FFFFFF"
                      >
                        <Link
                          className='no-underline'
                          href={handleKarmaNavigation(menu?.url)}
                          _focus={{ boxShadow: 'none' }}
                          prefetch
                          width={{xl: '100px', "2xl": 'unset'}}
                          display={{xl: 'inline-block', '2xl': 'unset'}}
                        >
                          {menu.title}
                        </Link>
                      </Text>
                    </li>
                  );
                }
              })}
            </ul>
          </nav>
        </Show>
        <Box 
        mr={{base:'40px', md:'45px'}}
        ml={'auto'}
        display={{base: 'flex', md: 'flex', lg: 'none'}}
        width={'auto'}
        height={'52px'}
        pt={{base: '13px', md: '5px'}}
        >
          <Box mr={'5px'}>
            {headerData?.map((menu, key) => {
              if (typeof window !== 'undefined' && !window.location.href?.includes('karma-book') && menu.key === 'get_your_book') { 
                const [path, hash] = window.location.href.split("#");
                return <Button
                  borderRadius={'6px'}
                  bg={'transparent'}
                  fontFamily={'var(--FedraSansStd-medium)'}
                  fontSize={{base:'14px', md: '18px'}}
                  fontWeight={400}
                  padding={'0px'}
                  px={'8px'}
                  h={{base: '26px', md:'40px'}}
                  _hover={{
                    backgroundColor:'#FFFFFF66'
                  }}
                >
                <Link className='no-underline'
                  // href={handleKarmaNavigation(menu.url)}
                  href={path + menu.url}
                >
                {menu.title}
                </Link>
                </Button>
              }
            })}
          </Box>
          <Show below="lg">
            <Box 
            mt={{ base: '3px', md: '5px' }}
            >
              {!showPrograms && (
                <svg 
                  onClick={() => setShowPrograms(true)}
                 style={{marginLeft:'100%'}} width={hamburgerIconSize} height={hamburgerIconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7L21 7M3 17L21 17" stroke="white" stroke-width="2" stroke-linecap="square"/>
                </svg>   
              )}
              {showPrograms && (
                <Box 
                mt={{ base: '-1px', md: '0px' }} marginLeft={'100%'}>
                <svg
                  onClick={() => {
                    setShowPrograms(false);
                    setMIndex({});
                  }}
                width={hamburgerIconSize} height={hamburgerIconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L19 19M19 5L5 19" stroke="white" stroke-width="2" stroke-linecap="square"/>
                </svg>
                </Box>
              )}
            </Box>
          </Show>
          <Show above="lg">
            <Box
              borderRadius="100%"
              bg="white"
              p="0.5rem"
              pos="relative"
              zIndex="9999"
            >
              <Link
                href={refineUrlDomain(calender?.url)}
                flex="1"
                display="flex"
                textDecor="none"
                _hover={{ textDecor: 'none' }}
                _focus={{ boxShadow: 'none' }}
                prefetch
              >
                <Icon
                  width="24px"
                  height="24px"
                  viewBox="0 0 24px 24px"
                  fill="none"
                  cursor="pointer"
                >
                  <path
                    d="M4 10H20M8 5V3M16 5V3M4 5H20V20H4V5Z"
                    stroke="#000"
                    stroke-width="2"
                    strokeLinecap="square"
                  />
                </Icon>{' '}
              </Link>
            </Box>
          </Show>
        </Box>
        <Show below="lg">
          {showPrograms && (
            <Portal>
              <Box
                pos="fixed"
                top={{ base: '52px', md: '70px' }}
                height={{
                  base: 'auto',
                  md: 'auto',
                }}
                maxH={'90vh'}
                left="0"
                width="100%"
                bg="#03003E"
                zIndex="1000"
                pt={'1rem'}
                overflowY={'auto'}
                paddingBottom={{ base: '0%', md: '0' }}
                px={{base: "5%", md: '3%'}}
                // borderTop="1px solid"
              >
                <Box
                  as="nav"
                  maxH="100%"
                  overflowY="auto"
                  w="100%"
                  pos="relative"
                  height="100%"
                >
                  {(
                    <List
                      className="container ul-reset"
                      display="flex"
                      flexDir="column"
                      height="100%"
                      py="8px"
                    >
                      {headerData.map((menu, index) => {
                        if (
                          menu.key === 'logo' ||
                          menu.key === 'search' ||
                          menu.key === 'calender' ||
                          menu.key === 'hollow-btn' || 
                          menu.key === 'karma_basics'
                        ) {
                          return null;
                        } else if (menu.submenuItems.length > 0) {
                          const middle = Math.ceil(menu.submenuItems.length / 2);
                          const firstHalf = menu.submenuItems.slice(0, middle);
                          const secondHalf = menu.submenuItems.slice(middle);
                          return (
                            <ListItem p="0"  key={index}>
                              <HStack
                                py="8px"
                                onClick={() => {
                                  setMIndex({...mIndex, [index]: !mIndex[index]});
                                }}
                                cursor="pointer"
                                pt={'1rem'}
                              >
                                <Text
                                  pl={'0.5rem'}
                                  color="#FFFFFF"
                                  fontFamily="var(--FedraSansStd-book)"
                                  fontFeatureSettings="'case' on"
                                  fontSize={{base:'16px', md:'18px'}}
                                  fontStyle="normal"
                                  lineHeight="160%"
                                  letterSpacing="0.32px"
                                >
                                  <Link className='no-underline' width={'100rem'} href={handleKarmaNavigation(menu.url)}>
                                  {menu.title}
                                  </Link>
                                </Text>
                                <ChevronDownIcon color={mIndex[index]/1 ? '#B7870C' : '#fff'} transform={ mIndex[index]/1 ? `rotate(180deg)` : undefined} ml={'auto'} w={6} h={6} />
                              </HStack>
                              <Box display={mIndex[index] / 1 ? 'flex' : 'none'} pt={'0.65rem'} pb={'0.65rem'}
                                borderRadius={'6px'}
                                border={'1px solid #B7870C'} bg={"#fff"} flexDir={{base: 'column', md: 'row'}}>
                                <Box width={{base: '100%', md:'50%'}}>
                                {mIndex[index] / 1 ? firstHalf.map((sub, key1) => {
                                  return (<>
                                    <Box key={key1}
                                      fontFamily="var(--FedraSansStd-book)"
                                      fontSize="14px"
                                      color={window.location.href?.includes(sub.url) ? '#000000' : "#B7870C"}
                                      fontWeight="400"
                                      pt={'0.65rem'}
                                      pb={'0.65rem'}
                                      px={'20px'}
                                      width={'100%'}
                                      _hover={{bgColor:"#F8F3B5"}}
                                    >
                                      <Link className='no-underline' href={handleKarmaNavigation(sub.url)}>
                                        {sub.title}
                                      </Link>
                                    </Box>
                                  </>)
                                }) : null}
                                </Box>
                                <Box width={{base: '100%', md:'50%'}}>
                                {mIndex[index] / 1 ? secondHalf.map((sub, key1) => {
                                  return (<>
                                    <Box key={key1}
                                      fontFamily="var(--FedraSansStd-book)"
                                      fontSize="14px"
                                      color={window.location.href?.includes(sub.url) ? '#000000' : "#B7870C"}
                                      fontWeight="400"
                                      pt={'0.65rem'}
                                      pb={'0.65rem'}
                                      px={'20px'}
                                      width={'100%'}
                                      _hover={{bgColor:"#F8F3B5"}}
                                    >
                                      <Link className='no-underline' href={handleKarmaNavigation(sub.url)}>
                                        {sub.title}
                                      </Link>
                                    </Box>
                                  </>)
                                }) : null}
                                </Box>
                              </Box>
                            </ListItem>
                          );
                        } else if(menu.key != 'get_your_book' && menu.key != "karma_basics") {
                          return (
                            <ListItem
                              p="0"
                              key={index}
                              _hover={{ boxShadow: 'none' }}
                              _focus={{ boxShadow: 'none' }}
                            >
                              <Link
                                href={handleKarmaNavigation(menu.url)}
                                onClick={() => setShowPrograms(false)}
                                className='no-underline'
                                _hover={{
                                  boxShadow: 'none',
                                  borderWidth: 0,
                                  borderColor: 'none',
                                }}
                                _focus={{
                                  boxShadow: 'none',
                                  borderWidth: 0,
                                  borderColor: 'none',
                                }}
                                borderColor="none"
                                borderWidth="0"
                                p="0"
                                prefetch
                              >
                                <HStack py="8px" cursor="pointer">
                                  <Text  
                                  pl={'0.5rem'}                                 
                                  pt={'0.5rem'}
                                  color="#FFFFFF"
                                  fontFamily="var(--FedraSansStd-book)"
                                  fontFeatureSettings="'case' on"
                                  fontSize={{base:'16px', md:'18px'}}
                                  fontStyle="normal"
                                  lineHeight="160%"
                                  letterSpacing="0.32px"
                                  >
                                    {menu?.title}
                                  </Text>
                                </HStack>
                              </Link>
                            </ListItem>
                          );
                        }
                      })}
                      <ListItem p="0">
                        <HStack py="8px" h="50px">
                          <Text
                            fontFamily="var(--FedraSansStd-book)"
                            fontSize="1rem"
                            fontStyle="normal"
                            color="#FEFAF6"
                            lineHeight="160%"
                            letterSpacing="0.32px"
                          ></Text>
                        </HStack>
                      </ListItem>
                    </List>
                  )}
                </Box>
              </Box>
            </Portal>
          )}
        </Show>
      </Box>
      <style global jsx>
        {`
          .no-underline {
            text-decoration: none !important;
          }
          .no-underline:hover,
          .no-underline:focus,
          .no-underline:active {
            text-decoration: none !important;
          }
          .search-wrap {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.5s;
            width: 0;
            height: 42px;
            box-sizing: border-box;
            margin-right: 60px;
            z-index: 100;
          }
          .search-wrap input {
            position: absolute;
            top: 1.5rem;
            width: 100%;
            height: 2.5rem;
            right: 0;
            line-height: 30px;
            outline: 0;
            border: 0;
            display: none;
            font-size: 1em;
            border-radius: 20px;
            padding: 0 20px;
            font-family: 'var(--FedraSansStd-medium)';
            background: #090d11;
            color: #fff;
          }
          .search-wrap .searchIcon {
            position: absolute;
            top: 2rem;
            right: 0;
          }
          .search-wrap:hover {
            cursor: pointer;
          }

          .search-wrap .active-input {
            display: block;
            width: 65vw;
            right: 0;
          }
          @media (max-width: 768px) {
            .search-wrap .active-input {
              display: block;
              width: 75vw;
              right: 0;
            }
          }
          .container {
            margin: 60px auto;
          }
          .ul-reset {
            padding-left: 0;
            margin-top: 0;
            margin-bottom: 0;
            list-style: none;
          }

          nav {
            font-size: 0;
          }
          nav > ul > li {
            display: inline-block;
            font-size: 14px;
            padding: ${paddingForLi};
            position: relative;
          }
          nav > ul > li:first-child {
            padding-left: 0;
          }
          nav > ul > li:last-child {
            padding-right: 0;
          }
          nav > ul > li > a {
            color: #fff;
            display: block;

            position: relative;
            padding: 20px 0;
            border-bottom: 3px solid transparent;
          }
          nav > ul > li:hover > a {
            color: #fff;

            border-bottom: 3px solid #69aae0;
          }

          .mega-menu {
            // background: #000;
            // display: none;
            left: 0;
            position: absolute;
            text-align: left;
            // width: 100%;
            z-index: 9000;
          }

          .mega-menu ul {
            float: left;
            margin-bottom: 20px;
            margin-right: 40px;
            // width: 205px;
          }
          .mega-menu ul:last-child {
            margin-right: 0;
          }

          .droppable {
            position: relative;
          }
          .droppable > a:after {
            font-size: 12px;
            padding-left: 6px;
            position: relative;
            top: -1px;
          }
          #ps-header {
            transition: all 0.2s linear;
            background: ${isMegaMenu > -1 || showPrograms
              ? '#010509'
              : theme === 'light'
              ? 'rgba(0, 0, 0, 0.30)'
              : '#010509'};
          }
          // .mega-menu:hover .mega-menu {
          //   display: block;
          // }
          .force-hide-mega .mega-menu {
            display: none !important;
          }
          html:hover:not(:has(.droppable:hover)) .mega-menu {
            display: none;
          }
          html:hover:not(:has(.droppable:hover)) .desktopDDIcon {
            color: #fff;
            transform: rotate(0deg);
          }
          .cf:before,
          .cf:after {
            content: ' ';
            display: table;
          }
          .cf:after {
            clear: both;
          }
        `}
      </style>
    </Box>
  ) : (
    ''
  );
};

export default Header;
